export function formatIBAN(iban: string): string {
  const cleaned = iban.replace(/\s/g, '').toUpperCase();
  return cleaned.match(/.{1,4}/g)?.join(' ') || cleaned;
}

export function cleanIBAN(iban: string): string {
  return iban.replace(/\s/g, '').toUpperCase();
}

export function validateIBAN(iban: string): boolean {
  const cleaned = cleanIBAN(iban);

  if (cleaned.length < 15 || cleaned.length > 34) {
    return false;
  }

  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(cleaned)) {
    return false;
  }

  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);

  const numericString = rearranged
    .split('')
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code >= 65 && code <= 90) {
        return (code - 55).toString();
      }
      return char;
    })
    .join('');

  let remainder = numericString;
  while (remainder.length > 2) {
    const block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
  }

  return parseInt(remainder, 10) % 97 === 1;
}

export function maskIBAN(iban: string): string {
  const cleaned = cleanIBAN(iban);
  if (cleaned.length < 6) return iban;

  const countryCode = cleaned.slice(0, 2);
  const last3 = cleaned.slice(-3);
  const middle = '•'.repeat(Math.max(0, cleaned.length - 5));

  return `${countryCode}${middle}${last3}`;
}

export function getLast3(iban: string): string {
  const cleaned = cleanIBAN(iban);
  return cleaned.slice(-3);
}

export function getIBANError(iban: string): string | null {
  if (!iban || iban.trim() === '') {
    return 'IBAN ist erforderlich';
  }

  const cleaned = cleanIBAN(iban);

  if (cleaned.length < 15) {
    return 'IBAN zu kurz (min. 15 Zeichen)';
  }

  if (cleaned.length > 34) {
    return 'IBAN zu lang (max. 34 Zeichen)';
  }

  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(cleaned)) {
    return 'Ungültiges IBAN-Format (muss mit 2 Buchstaben + 2 Ziffern beginnen)';
  }

  if (!validateIBAN(iban)) {
    return 'Ungültige IBAN (Prüfziffer fehlgeschlagen)';
  }

  return null;
}
